// Copyright (c) 2016 Deere & Company

import Claim from '@deere/cps-it.warranty-model-factory/lib/claim';
import t from 'tcomb';

const Claims = t.list(Claim, 'Claims');

export const getDefaultState = () => new Claims([]);

export default Claims;



// WEBPACK FOOTER //
// ./src/product/details/state/claims.js